export default "__VITE_ASSET__BStguDsT__"